(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Teams
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('ActionSendEmailEes', ActionSendEmailEes);

  function ActionSendEmailEes($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/sendemail/:id/:ido', {id: '@_id',ido: '@_ido'});
  }
}());


